<template>
    <div id="print" class="row align-items-center">
        <div v-if="loading" class="col-12 mt-5 mb-5" v-loading="true"></div>
        <div v-else class="col-12">
            <h1 class="text-center">{{ registration | name }}</h1>
            <div v-html="registration.badgeMessage" class="text-center" style="font-size: 18px"></div>
            <div class="d-flex justify-content-center">
                <img :src="$store.state.baseUrl + registration.qr" width="192px"/>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data () {
        return {
            loading: true,
            registration: {}
        }
    },
    mounted () {
        this.getRegistration()
    },
    methods: {
        getRegistration: async function () {
            this.loading = true
            try {
                const response = await this.$store.dispatch('get', { path: 'registrations', key: 'registration', id: this.$route.params.registrationId })
                this.registration = {
                    ...response.data.registration,
                    badgeMessage: this.renderBadgeMessage(response.data.registration)
                }
            } catch (e) {
                console.log('error getting registration')
            }
            this.loading = false
        },
        renderBadgeMessage: function (registration) {
            let html = registration.type.badgeContent

            registration.fields.forEach(field => {
                if (field.type === 'checkboxes') {
                    let text = ''
                    field.value.forEach(value => {
                        text += field.labels.split('\n')[field.values.split('\n').indexOf(value)] + ' '
                    })
                    html = html.replace(new RegExp(field.name, 'g'), text)
                } else if (field.type === 'radio' || field.type === 'list') {
                    html = html.replace(new RegExp(field.name, 'g'), field.labels.split('\n')[field.values.split('\n').indexOf(field.value)])
                } else {
                    html = html.replace(new RegExp(field.name, 'g'), field.value)
                }
            })

            html = html.replace(/\$|{|}/g, '')
            return html
        }
    },
    filters: {
        name: (registration) => {
            let name = ''
            const firstName = registration.fields.find(field => field.fieldMapping === 'firstName')
            const lastName = registration.fields.find(field => field.fieldMapping === 'lastName')

            if (firstName) name += firstName.value + ' '
            if (lastName) name += lastName.value

            return name
        }
    }
}
</script>

<style lang="sass">
#print
    background-color: white
    min-height: 100vh
</style>